var _rect, _path, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpAuthenticationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 200,
    viewBox: "0 0 250 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 200,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 65C205.866 65 209 68.134 209 72C209 75.866 205.866 79 202 79H162C165.866 79 169 82.134 169 86C169 89.866 165.866 93 162 93H184C187.866 93 191 96.134 191 100C191 103.866 187.866 107 184 107H173.826C168.952 107 165 110.134 165 114C165 116.577 167 118.911 171 121C174.866 121 178 124.134 178 128C178 131.866 174.866 135 171 135H88C84.134 135 81 131.866 81 128C81 124.134 84.134 121 88 121H49C45.134 121 42 117.866 42 114C42 110.134 45.134 107 49 107H89C92.866 107 96 103.866 96 100C96 96.134 92.866 93 89 93H64C60.134 93 57 89.866 57 86C57 82.134 60.134 79 64 79H104C100.134 79 97 75.866 97 72C97 68.134 100.134 65 104 65H202ZM202 93C205.866 93 209 96.134 209 100C209 103.866 205.866 107 202 107C198.134 107 195 103.866 195 100C195 96.134 198.134 93 202 93Z",
    fill: "#F3F7FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95.5,
    y: 46.5,
    width: 59,
    height: 99,
    rx: 6.5,
    fill: "white",
    stroke: "#1B69FD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 51,
    width: 20,
    height: 5,
    rx: 2.5,
    fill: "#1B69FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101 139V102.412C101 101.228 103.193 100.883 103.666 101.968C110.145 116.854 123.852 127.582 142.557 138.096C143.46 138.604 143.107 140 142.07 140H102C101.448 140 101 139.552 101 139Z",
    fill: "#E8F0FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 97C131.5 95.067 133.067 93.5 135 93.5H177C178.933 93.5 180.5 95.067 180.5 97V119.605C180.5 120.349 179.896 120.953 179.151 120.953C178.844 120.953 178.556 121.1 178.375 121.348L173.167 128.469V122.453C173.167 121.625 172.495 120.953 171.667 120.953H156H135C133.067 120.953 131.5 119.386 131.5 117.453V97Z",
    fill: "white",
    stroke: "#1B69FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.233 103.2C149.111 103.2 150.633 104.722 150.633 106.6C150.633 108.478 149.111 110 147.233 110C145.356 110 143.833 108.478 143.833 106.6C143.833 104.722 145.356 103.2 147.233 103.2ZM158 103.2C159.878 103.2 161.4 104.722 161.4 106.6C161.4 108.478 159.878 110 158 110C156.122 110 154.6 108.478 154.6 106.6C154.6 104.722 156.122 103.2 158 103.2ZM168.767 103.2C170.644 103.2 172.167 104.722 172.167 106.6C172.167 108.478 170.644 110 168.767 110C166.889 110 165.367 108.478 165.367 106.6C165.367 104.722 166.889 103.2 168.767 103.2Z",
    fill: "white",
    stroke: "#1F64E7",
    strokeWidth: 1.41667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154 64H155C155.552 64 156 64.4477 156 65V72C156 72.5523 155.552 73 155 73H154V64Z",
    fill: "#1B69FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96 64H95C94.4477 64 94 64.4477 94 65V72C94 72.5523 94.4477 73 95 73H96V64Z",
    fill: "#1B69FD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96 77H95C94.4477 77 94 77.4477 94 78V85C94 85.5523 94.4477 86 95 86H96V77Z",
    fill: "#1B69FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpAuthenticationLogo);
export default __webpack_public_path__ + "static/media/OtpAuthenticationLogo.bda9f6c3362994eb3f20df7bf8caf128.svg";
export { ForwardRef as ReactComponent };